var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.69 37.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "allergen_bg_color",
    className: "svgBg",
    d: "M37.69 18.84c0,10.41 -8.44,18.85 -18.85,18.85 -10.4,0 -18.84,-8.44 -18.84,-18.85 0,-10.4 8.44,-18.84 18.84,-18.84 10.41,0 18.85,8.44 18.85,18.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgText",
    d: "M25.1 16.26l-2.23 -3.9 0 -2.15c0,-0.32 -0.26,-0.58 -0.57,-0.58l-6.33 0c-0.32,0 -0.58,0.26 -0.58,0.58l0 2.12 -2.77 3.88c-0.02,0.02 -0.02,0.05 -0.04,0.07 -0.01,0.02 -0.02,0.04 -0.03,0.06 -0.02,0.06 -0.04,0.13 -0.04,0.2l0 10.94c0,0.32 0.26,0.57 0.58,0.57l11.51 0c0.32,0 0.58,-0.25 0.58,-0.57l0 -10.94c0,-0.1 -0.03,-0.2 -0.08,-0.28zm-3.38 -5.47l0 0 0 1.15 -5.18 0 0 -1.15 5.18 0zm-8.06 16.11l0 0 0 -9.78 3.46 0c0.31,0 0.57,-0.26 0.57,-0.58 0,-0.32 -0.26,-0.57 -0.57,-0.57l-2.91 0 2.05 -2.88 5.05 0 -1.82 3.17c-0.04,0.08 -0.07,0.18 -0.07,0.28l0 10.36 -5.76 0zm10.36 0l0 0 -3.45 0 0 -10.21 1.73 -3.02 1.72 3.02 0 10.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.ca79f863e428e4e6bfc4f887c5bda7f0.svg";
export { ForwardRef as ReactComponent };